import myTheme from './theme'
import stylesConfig from './config'
import { themedTextColor, themedTextColorRgb } from './themed-text-color'

export { myTheme, stylesConfig, themedTextColor, themedTextColorRgb }



// WEBPACK FOOTER //
// ./src/styles/index.js